export enum LocationType {
  Global,
  Region,
  BusinessUnit,
  Country
}